import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';

@Component({
  selector: 'ui-checkbox-input',
  templateUrl: './checkbox-input.component.html',
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxInputComponent implements OnInit {
  @Input() public control: FormControl<boolean | null> = new FormControl<
    boolean | null
  >(null);
  @Input() public color: ThemePalette = 'primary';
  @Input() public label = '';
  @Input() public isDisabled = false;

  public ngOnInit(): void {
    if (this.isDisabled) {
      this.control.disable();
    }
  }
}
